// Stealing code from here: https://mui.com/material-ui/react-avatar/
function stringToColor(string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

export default function stringAvatar(name) {
    if (!name) {
        return {
            sx: {
                bgcolor: '#ccc',
            },
            children: 'G',
        };
    }
    // grab the first two letters of the name
    // and convert them to uppercase
    const firstTwoLetters = name
        .split(' ')
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join('');

    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${firstTwoLetters}`,
    };
}
